import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';
export class Maintenance extends Component {
    displayName = Maintenance.name

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Maintenance");
        if (window.location.pathname == "/Maintenance") {
            const metaRobots = document.createElement('meta');
            metaRobots.name = 'robots';
            metaRobots.content = 'noindex';
            document.head.appendChild(metaRobots);
        }
       
    }
    render() {
        const meta = {
            title: "Kluwer Law Online - Maintenance",
            canonical: window.location.href,
        }
        return (
            <DocumentMeta {...meta}>
            <div className="col-12" >
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">
                        <p className="franziskafont">The page requested cannot be found</p>
                        <p>Apologies for any inconvenience.</p>
                        <p>Here are some options to help get you back on track: </p>
                            <p><span style={{ fontSize: '30px', color: '#80c342' }}>1</span>&nbsp;&nbsp; Notify our Technical Support team of the issue you have
                            encountered via our <Link to="/ContactSales" className="LinkClass"> Tech support page </Link> </p>
                            <p><span style={{ fontSize: '30px', color: '#80c342' }}>2</span>&nbsp;&nbsp; Continue your journey via the <Link to="/" className="LinkClass"> Home page </Link></p>
                    </div>     
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
            </div>
                </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Maintenance.jsx